import config from 'config';

export type ImageSize = 'thum' | 'prof' | 'orig';

export function buildPobProfImgUrl(pob: any, size: ImageSize = 'thum') {
	if (!pob) return null;
	return (
		config.dfS3WebImages + 'pax/' + pob.personID._id + '/' + pob.personID._id + `_${size}.jpeg`
	);
}

export function buildPersonProfImgUrl(person: any, size: ImageSize = 'thum') {
	if (!person) return null;
	return config.dfS3WebImages + 'pax/' + person._id + '/' + person._id + `_${size}.jpeg`;
}
